"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
require("./index.css");
var _default = exports["default"] = function _default(_ref) {
  var anchorEl = _ref.anchorEl,
    contacts = _ref.contacts;
  return /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    id: "contact-poper",
    open: !!_react["default"].Children.count(contacts),
    container: anchorEl,
    anchorEl: anchorEl,
    placement: "bottom-start"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-auto bg-card rounded shadow-lg",
    style: {
      width: 400,
      maxHeight: '100vh'
    }
  }, contacts));
};
//# sourceMappingURL=index.js.map